(() => {
	// Slides visible at each breakpoint, smallest first.
	//
	// Two things were wrong before:
	//   1. Phones were hardcoded to 2. For circular category cards that is far
	//      too few -- they render enormous and you cannot see the categories.
	//   2. The ladder was not monotonic. With columnCount 7 the 576px step
	//      resolved to 3.66, so widening the viewport past 575px SHOWED FEWER
	//      items than a narrower phone did.
	//
	// The mobile count is now a section setting, and each step is clamped to at
	// least the step below it, so the count can never drop as the screen grows.
	//
	// The first mobile default, 4.5, overcorrected: on a 375px phone a card was
	// ~67px wide with a ~43px image, and Danish titles ("Vedligehold") are wider
	// than that, so they ran into each other. 3.5 is the default now, and the
	// CSS keeps a title inside its own card whatever the count is set to.
	const slidesLadder = (columnCount, mobileColumns) => {
		const c = Number(columnCount);
		const m = Number(mobileColumns) > 0 ? Number(mobileColumns) : 3.5;

		const raw = [
			[0, m],
			[576, c - 4 + 0.66],
			[990, c - 2 + 0.66],
			[1150, (c <= 6 ? c : 6) + 0.56],
			[1250, c + 0.56],
		];

		let running = 0;
		return raw.map(([bp, value]) => {
			running = Math.max(running, value);
			return [bp, running];
		});
	};

	const getInitialSlidesPerView = (columnCount, mobileColumns) => {
		const w = window.innerWidth;
		const ladder = slidesLadder(columnCount, mobileColumns);
		let value = ladder[0][1];
		ladder.forEach(([bp, v]) => {
			if (w >= bp) value = v;
		});
		return value;
	};

	const initSlider = (section) => {
		let collectionsSlider;

		if (document.currentScript) {
			collectionsSlider = document.currentScript.parentElement.querySelectorAll(
				".js-slider-collections-slider"
			);
		} else {
			collectionsSlider = section.querySelectorAll(
				".js-slider-collections-slider"
			);
		}

		if (collectionsSlider && collectionsSlider.length > 0) {
			collectionsSlider.forEach((el) => {
				const speed1 = el.getAttribute("data-duration");
				const columnCount = el.getAttribute("data-column-count");
				const mobileColumns = el.getAttribute("data-mobile-column-count");
				const prevBtn = section.querySelector(".swiper-button-prev");
				const nextBtn = section.querySelector(".swiper-button-next");

				el.style.visibility = 'hidden';

				const logosSwiper1 = new Swiper(el, {
					on: {
						init() {
							el.style.visibility = 'visible';
						}
					},
					slidesPerView: getInitialSlidesPerView(columnCount, mobileColumns),
					// Tighter gutter on phones than the 16px above 576px: the
					// cards are small, and the gap comes out of their width.
					// Keep in step with the pre-init width in
					// template-list-collections.css.
					spaceBetween: 10,
					autoplay: false,
					direction: "horizontal",
					loop: false,
					speed: speed1,
					shortSwipes: true,
					longSwipes: true,
					allowTouchMove: true,
					navigation:
						prevBtn && nextBtn ? { nextEl: nextBtn, prevEl: prevBtn } : false,
					breakpoints: slidesLadder(columnCount, mobileColumns)
						.filter(([bp]) => bp > 0)
						.reduce((acc, [bp, value]) => {
							acc[bp] = { slidesPerView: value, spaceBetween: bp >= 990 ? 20 : 16 };
							return acc;
						}, {}),
					mousewheel: {
						forceToAxis: true,
					},
				});
			});
		}
	};

	const initSection = (section) => {
		let sectionCollections;

		if (document.currentScript) {
			sectionCollections = document.currentScript.parentElement;
		} else {
			sectionCollections = section;
		}

		let initialized = false;

		const sectionResizeObserver = new ResizeObserver((entries) => {
			if (!initialized) {
				initialized = true;
				return;
			}

			const [entry] = entries;
			const sliders = entry.target.querySelectorAll(
				".js-slider-collections-slider"
			);
			const slidersSlow = entry.target.querySelectorAll(
				".js-slider-collections-slider-slow"
			);

			if (sliders.length != 0) {
				sliders.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			if (slidersSlow.length != 0) {
				slidersSlow.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			initSlider(sectionCollections);
		});

		initSlider(sectionCollections);

		sectionResizeObserver.observe(sectionCollections);
	};

	initSection();

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();